export const pxToRem = (px) => `${px / 16}rem`;
